import { lazy } from "react";
import { connect } from "react-redux";
import { currentUser } from "../../../../store/auth/selectors";
import {
  loading as isLoadingAllEmployees,
  loadingAction as isLoadingAction,
  detail as employeeDetailData,
} from "../../../../store/administration/selectors/employees";
import {
  loading as isLoadingUbications,
  data as ubicationsData,
} from "../../../../store/administration/selectors/ubications";
import {
  loading as isLoadingPositions,
  data as positionsData,
} from "../../../../store/administration/selectors/positions";

const ShowEmployee = lazy(() => import("./ShowEmployee"));

const mapStateToProps = (state) => ({
  currentUser: currentUser(state),
  isLoading: isLoadingAllEmployees(state),
  isLoadingAction: isLoadingAction(state),
  employee: employeeDetailData(state),
  isLoadingUbications: isLoadingUbications(state),
  ubications: ubicationsData(state),
  isLoadingPositions: isLoadingPositions(state),
  positions: positionsData(state),
});

export default connect(mapStateToProps)(ShowEmployee);
